/*
 * @Author: ldx
 * @Date: 2022-05-27 15:15:27
 * @LastEditors: ldx
 * @LastEditTime: 2022-07-27 16:30:15
 * @Description: 加密/解密工具
 */
const CryptoJS = require('crypto-js')

//秘钥，必须由16位字符组成
const secretKey = '122FF23419AB14EF' // 不用乱改（修改需要一后端一起改）
// const secretIv = '1234567890abcdef'
// 16位十六进制数作为密钥
const key = CryptoJS.enc.Utf8.parse('122FF23419AB14EF')
// 16位十六进制数作为密钥偏移量
const iv = CryptoJS.enc.Utf8.parse('1234567890abcdef')
// const iv = CryptoJS.enc.Utf8.parse('1234567890abcdef')

/**
 * @description: 加密内容(项目内部使用)
 * @param {*} encryptText  明文
 * @return {*} 密文
 */
function encrypt(encryptText) {
  const text = CryptoJS.enc.Utf8.parse(encryptText)
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}
/**
 * @description: 解密内容
 * @param {*} decryptText  密文
 * @return {*} 明文
 */
function decrypt(decryptText) {
  const decrypted = CryptoJS.AES.decrypt(decryptText, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}
/**
 * @description: 解密内容
 * @param {*} decryptText  密文
 * @return {*} 明文
 */
function decryptBySecretIV(decryptText, secretIV) {
  const cfg = {
    iv: CryptoJS.enc.Utf8.parse(secretIV),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }
  const decrypted = CryptoJS.AES.decrypt(decryptText, key, cfg)
  const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}

/**
 * @description: AES加密方法
 * @param content 要加密的字符串
 * @returns {string} 加密结果
 */
function aesEncrypt(content) {
  let key = CryptoJS.enc.Utf8.parse(secretKey)
  let srcs = CryptoJS.enc.Utf8.parse(content)
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

/**
 * @description:AES解密方法
 * @param encryptStr 密文
 * @returns {string} 明文
 */
function aesDecrypt(encryptStr) {
  let key = CryptoJS.enc.Utf8.parse(secretKey)
  let decrypt = CryptoJS.AES.decrypt(encryptStr, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}
/**
 * @description: MD5加密
 * @param {*} content
 * @return {*}
 */
function MD5(content) {
  return CryptoJS.MD5(content)
}
/**
 * @description: 加密成Base64
 * @param {*} encStr 加密字符串
 * @return {*} 密文
 */
function encBase64(encStr) {
  return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encStr))
}
/**
 * @description: 解密Base64内容
 * @param {*} decStr 解密字符串
 * @return {*} 明文
 */
function decBase64(decStr) {
  return CryptoJS.enc.Base64.parse(decStr).toString(CryptoJS.enc.Utf8)
}

export { encrypt, decrypt, decryptBySecretIV, aesEncrypt, aesDecrypt, MD5, encBase64, decBase64 }
